export default "__VITE_ASSET__D0zKKPaJ__"